/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const auth = {
    // 买家登录
    buyerLogin (params) {
        return axios.post(`${base.dev}/v2/acheteurs/login`,params);
    },
    // 买家注册
    buyerSign (params) {
        return axios.post(`${base.dev}/v2/acheteurs/regist`,params,{
            headers: {'Content-Type': 'multipart/form-data'}
        });
    },
    // 买家注册
    old_station_connect_login (params) {
        return axios.post(`${base.dev}/v2/acheteurs/old_station_connect_login`,params);
    },
    //卖家注册
    sellerSign(params){
        return axios.post(`${base.dev}/v2/vendeurs/account/register`,params,{
            headers: {'Content-Type': 'multipart/form-data'}
        });
    },
    checkEmail (params) {//检查邮箱是否已注册
        return axios.post(`${base.dev}/v2/vendeurs/account/checkEmail`,params);
    },
    // 获取国家
    countryGet () {
        return axios.get(`${base.dev}/pays`);
    },
    // 获取经营范围
    businessScope (query) {
        return axios.get(`${base.dev}/activites`,{params:query});
    },
    //检查邮箱是否已注册
    verify_email(params){
        return axios.post(`${base.dev}/v2/acheteurs/verify_email`,params);
    },
    //买家重置密码
    reset_password(params){
        return axios.post(`${base.dev}/v2/acheteurs/reset_password`,params);
    },
    //验证税号
    verify_siret(params){
        return axios.post(`${base.dev}/v2/acheteurs/verify_siret`,params);
    }
    // 其他接口…………
}

export default auth;
